interface Props {
  label: string;
  url: string;
  subtitle?: string;
  ctaId?: string;
  source?: string;
  /** 'primary' renders a filled brand card to anchor the page's main action. */
  variant?: 'primary' | 'secondary';
}

export default function CtaCard({
  label,
  url,
  subtitle,
  ctaId,
  source,
  variant = 'secondary',
}: Props) {
  const styles =
    variant === 'primary'
      ? 'bg-brand-bg text-white hover:bg-brand-bg-hover shadow-lg shadow-black/25'
      : 'bg-surface-2 text-heading hover:bg-surface';

  return (
    <a
      href={url}
      data-cta={ctaId ?? 'assessment-result-cta'}
      data-cta-source={source ?? 'result'}
      className={`group flex items-center justify-between gap-4 rounded-xl p-5 transition ${styles}`}
    >
      <div>
        <div className={`font-semibold ${variant === 'primary' ? 'text-white' : 'text-brand'}`}>
          {label}
        </div>
        {subtitle && (
          <div className={`mt-1 text-sm ${variant === 'primary' ? 'text-white/90' : 'text-muted'}`}>
            {subtitle}
          </div>
        )}
      </div>
      <span
        aria-hidden
        className={`shrink-0 text-xl transition-transform group-hover:translate-x-1 ${
          variant === 'primary' ? 'text-white' : 'text-brand'
        }`}
      >
        →
      </span>
    </a>
  );
}
